import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FileUploader } from "react-drag-drop-files";
import { FaRegAddressCard } from "react-icons/fa";
import { FiUploadCloud } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "../Components/CustomToast/CustomToast";
import { uploadDoc, uploadDocURL } from "../Services/api";

const fileTypes = ["JPG", "PNG", "JPEG"];
// import Sonnet from '../../components/Sonnet';
function DocumentsUpload() {
  const navigate = useNavigate();

  const [filePan, setFile] = useState(null);
  const [fileAadhar, setFile1] = useState(null);
  const [img, setImg] = useState(null);
  const [img1, setImg1] = useState(null);

  const handleChange = (filePan) => {
    setFile(filePan);
    setImg(URL.createObjectURL(filePan[0]));
  };
  const handleChange1 = (fileAadhar) => {
    setFile1(fileAadhar);
    setImg1(URL.createObjectURL(fileAadhar[0]));
  };
  const PanCard = (
    <span>
      <FaRegAddressCard /> Pan Card
    </span>
  );

  const stack2 = (
    <div className="drop-layout d-flex flex-column align-items-center justify-content-center">
      <div className="box box-1 h-100 text-center p-4">
        <div className="upload-sub-head text-center mb-5">
          <h4>Upload pan card photo here*</h4>
        </div>
        <div className="drop-icon">
          <FiUploadCloud />
        </div>
        <div className="drop-text">
          <h2>Drop Your Pan Card</h2>
          <p>(Minimal size 1660 x 960px )</p>
        </div>
        <div className="drop-btn ">
          <Link to="">select file</Link>
        </div>
      </div>
    </div>
  );
  const AadharCard = (
    <span>
      <FaRegAddressCard /> Aadhar Card
    </span>
  );

  const stack3 = (
    <div className="drop-layout d-flex flex-column align-items-center justify-content-center">
      <div className="box box-1 h-100 text-center p-4">
        <div className="upload-sub-head text-center mb-5">
          <h4>Upload Adhaar card photo here*</h4>
        </div>
        <div className="drop-icon">
          <FiUploadCloud />
        </div>
        <div className="drop-text">
          <h2>Drop Your Aadhar Card</h2>
          <p>(Minimal size 250mb )</p>
        </div>
        <div className="drop-btn ">
          <Link to="">select file</Link>
        </div>
      </div>
    </div>
  );

  const doSubmitDoc = async () => {
    try {
      const formDataPan = new FormData();
      const formDataAdhar = new FormData();
      for (const key of filePan) {
        formDataPan.append("file", key);
      }
      for (const key of fileAadhar) {
        formDataAdhar.append("file", key);
      }
      const respPan = await uploadDoc(formDataPan);
      const respAdhar = await uploadDoc(formDataAdhar);

      const request = {
        aadharCardUrl: respAdhar.data,
        panCardUrl: respPan.data,
      };
      const resp = await uploadDocURL(request);

      toast(<CustomToast type="success" message={resp.msg} />, {
        autoClose: 3000,
      });
      navigate("/properties");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <div className="doc-area">
        <div className="container h-100">
          <div className="doc-box">
            <div className="doc-inner">
              <Tabs
                defaultActiveKey="home"
                transition={false}
                variant="pills"
                id="noanim-tab-example"
                className="mb-4"
              >
                <Tab eventKey="home" title={PanCard}>
                  {/* <Sonnet /> */}
                  <FileUploader
                    children={stack2}
                    multiple={true}
                    handleChange={handleChange}
                    name="filePan"
                    types={fileTypes}
                  />
                  <div className="text-center">
                            <div className="drop-text mt-3 mb-2">
                             <h2>Image Preview</h2>

                            </div>
                            <img className='upload-i2' src={img} />
                            <p className="file-select">

                              {filePan ? `File name: ${filePan[0].name}` : ""}
                            </p>
                          </div>
                  <p className="file-select">
                    {/* {filePan ? `File name: ${filePan[0].name}` : ""} */}
                  </p>
                </Tab>
                <Tab eventKey="profile" title={AadharCard}>
                  <FileUploader
                    children={stack3}
                    multiple={true}
                    handleChange={handleChange1}
                    name="fileAadhar"
                    types={fileTypes}
                  />
                 <div className="text-center">
                            <div className="drop-text mt-3 mb-2">
                             <h2>Image Preview</h2>

                            </div>
                            <img className='upload-i2' src={img1} />
                            <p className="file-select">
                              {fileAadhar
                                ? `File name: ${fileAadhar[0].name}`
                                : ""}
                            </p>
                          </div>
                </Tab>
              </Tabs>
              <div className="doc-buttons text-center">
                {/* <Link className="doc-back" to="">
                  Back
                </Link> */}
                <Link
                  className="doc-back doc-proceed"
                  onClick={() => {
                    doSubmitDoc();
                  }}
                >
                  Proceed
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DocumentsUpload;
